export const normalizeBaseUrl = (raw?: string): string => {
  const value = (raw || '').trim();
  if (!value) return '';

  const withProtocol = /^https?:\/\//i.test(value) ? value : `https://${value}`;
  return withProtocol.replace(/\/+$/, '');
};

export const buildSupabaseFunctionUrl = (rawBaseUrl: string | undefined, fnName: string): string => {
  const baseUrl = normalizeBaseUrl(rawBaseUrl);
  const cleanFn = fnName.replace(/^\/+/, '');
  return `${baseUrl}/functions/v1/${cleanFn}`;
};

export const resolveOpenRouterChatUrl = (raw?: string): string => {
  const fallback = 'https://openrouter.ai/api/v1/chat/completions';
  if (!raw) return fallback;

  const normalized = normalizeBaseUrl(raw);
  if (!normalized) return fallback;

  try {
    const parsed = new URL(normalized);
    if (/\/api\/v1\/chat\/completions\/?$/i.test(parsed.pathname)) return normalized;
    parsed.pathname = `${parsed.pathname.replace(/\/+$/, '')}/api/v1/chat/completions`;
    return parsed.toString().replace(/\/+$/, '');
  } catch {
    return fallback;
  }
};
